// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buy-btn[data-v-71c93a5e]{background:#fff;border:2px solid #504e4d;color:#504e4d;font-size:20px;font-weight:500;width:100%}.buy-btn[data-v-71c93a5e]:active{background:#c5c3c3}.buy-btn[data-v-71c93a5e]:focus,.buy-btn[data-v-71c93a5e]:hover{background:#d9d8d7}.buy-btn .loader-showbox[data-v-71c93a5e]{background:#fff;--color:#504e4d}.buyed[data-v-71c93a5e]{font-size:20px;font-weight:500;text-transform:uppercase;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
